import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
    createRequestActionTypes,
} from '../../lib/createRequestSaga';
import * as searchAPI from '../../lib/api/searchapi';
import { takeLatest } from 'redux-saga/effects';

/**
 * API 서버에 Request 하는 Action Type
 */
const [
    REQ_TYPE_GET_BRNAD,
    REQ_TYPE_GET_BRNAD_SUCCESS,
    REQ_TYPE_GET_BRNAD_FAILURE,
] = createRequestActionTypes('search/GET_BRAND');

const [
    REQ_TYPE_GET_BRNAD_DEFAULT,
    REQ_TYPE_GET_BRNAD_DEFAULT_SUCCESS,
    REQ_TYPE_GET_BRNAD_DEFAULT_FAILURE,
] = createRequestActionTypes('search/GET_BRAND_DEFAULT');


const [
    REQ_TYPE_GET_BRNAD_PRODUCT,
    REQ_TYPE_GET_BRNAD_PRODUCT_SUCCESS,
    REQ_TYPE_GET_BRNAD_PRODUCT_FAILURE,
] = createRequestActionTypes('search/GET_BRAND_PRODUCT');

const [
    REQ_TYPE_GET_BRNAD_PRODUCT_DEFAULT,
    REQ_TYPE_GET_BRNAD_PRODUCT_DEFAULT_SUCCESS,
    REQ_TYPE_GET_BRNAD_PRODUCT_DEFAULT_FAILURE,
] = createRequestActionTypes('search/GET_BRAND_PRODUCT_DEFAULT');

const [
    REQ_TYPE_GET_STAT,
    REQ_TYPE_GET_STAT_SUCCESS,
    REQ_TYPE_GET_STAT_FAILURE,
] = createRequestActionTypes('search/GET_STAT');

const [
    REQ_TYPE_GET_BRNAD_PRODUCT_ADD,
    REQ_TYPE_GET_BRNAD_PRODUCT_ADD_SUCCESS,
    REQ_TYPE_GET_BRNAD_PRODUCT_ADD_FAILURE,
] = createRequestActionTypes('search/REQ_TYPE_GET_BRNAD_PRODUCT_ADD');

const [
    REQ_TYPE_GET_CATEGORY,
    REQ_TYPE_GET_CATEGORY_SUCCESS,
    REQ_TYPE_GET_CATEGORY_FAILURE,
] = createRequestActionTypes('search/REQ_TYPE_GET_CATEGORY');

const SET_SEARCH_TEXT = 'search/SET_SEARCH_TEXT';
const SET_SAVE_TEXT = 'search/SET_SAVE_TEXT';
const SET_SEARCH_FILTER_INDEX = 'search/SET_SEARCH_FILTER_INDEX';
// 브랜드 필터 인자값 저장.
const SET_SEARCH_FILTER_DATA = 'search/SET_SEARCH_FILTER_DATA';

const SET_SEARCH_BRAND_ERROR_RESET = 'search/SET_SEARCH_BRAND_ERROR_RESET';
const SET_SEARCH_BRAND_DEFAULT_ERROR_RESET = 'search/SET_SEARCH_BRAND_DEFAULT_ERROR_RESET';
const SET_SEARCH_BRAND_PRODUCT_ERROR_RESET = 'search/SET_SEARCH_BRAND_PRODUCT_ERROR_RESET';
const SET_SEARCH_BRAND_PRODUCT_DEFAULT_ERROR_RESET = 'search/SET_SEARCH_BRAND_PRODUCT_DEFAULT_ERROR_RESET';
const SET_SEARCH_STAT_ERROR_RESET = 'search/SET_SEARCH_STAT_ERROR_RESET';
const SET_SEARCH_BRAND_PRODUCT_ADD_ERROR_RESET = 'search/SET_SEARCH_BRAND_PRODUCT_ADD_ERROR_RESET';
//브랜드 검색
export const getBrandAction = createAction(REQ_TYPE_GET_BRNAD, (search) => {
    return { search }
});
//브랜드 검색 결과 없을 시 전시 브랜드 정보
export const getBrandDefaultAction = createAction(REQ_TYPE_GET_BRNAD_DEFAULT);
//상품 검색 최초 stat 정보와 함께 전체 검색 결과 가져오기
export const getStatAction = createAction(REQ_TYPE_GET_STAT, (search) => {
    return { search }
});
//상품 검색에 있는 브랜드 ㄱ,ㄴ, ㄷ 필터 적용
export const getBrandProductInfoAction = createAction(REQ_TYPE_GET_BRNAD_PRODUCT, (search, brandId, data, type, offset) => {
    return { search, brandId, data, type, offset }
});
//상품 검색에 있는 브랜드 ㄱ,ㄴ, ㄷ 필터 적용 더보기 추가.
export const getBrandProductInfoAddAction = createAction(REQ_TYPE_GET_BRNAD_PRODUCT_ADD, (search, brandId, data, type, offset) => {
    return { search, brandId, data, type, offset }
});

export const getCategoryInfoAction = createAction(REQ_TYPE_GET_CATEGORY, (search) => {
    return { search }
});

//상품 검색에 실패한 경우, 전시 브랜드 포함 상품 데이터 가져오기
export const getBrandProductDefaultAction = createAction(REQ_TYPE_GET_BRNAD_PRODUCT_DEFAULT);

//상품 검색 텍스트 지정
export const setSearchTextAction = createAction(SET_SEARCH_TEXT);
export const setSaveTextAction = createAction(SET_SAVE_TEXT);

//필터 정보 index 저장
export const setSearchFilerIndexAction = createAction(SET_SEARCH_FILTER_INDEX);
//선택된 filter 데이터 저장
export const setSearchFilterDataAction = createAction(SET_SEARCH_FILTER_DATA);

//error 데이터 null 설정
export const reSetBrandErrorAction = createAction(SET_SEARCH_BRAND_ERROR_RESET);
export const reSetBrandDefaultErrorAction = createAction(SET_SEARCH_BRAND_DEFAULT_ERROR_RESET);
export const reSetBrandProductErrorAction = createAction(SET_SEARCH_BRAND_PRODUCT_ERROR_RESET);
export const reSetBrandProductDefaultErrorAction = createAction(SET_SEARCH_BRAND_PRODUCT_DEFAULT_ERROR_RESET);
export const reSetStatErrorAction = createAction(SET_SEARCH_STAT_ERROR_RESET);
export const reSetBrandProductAddErrorAction = createAction(SET_SEARCH_BRAND_PRODUCT_ADD_ERROR_RESET);

/**
 * SAGA API 에서 REST API 호출 
 */
const getBrandSaga = createRequestSaga(REQ_TYPE_GET_BRNAD, searchAPI.getBrand);
const getBrandDefaultSaga = createRequestSaga(REQ_TYPE_GET_BRNAD_DEFAULT, searchAPI.getBrandDefault);
const getStatSaga = createRequestSaga(REQ_TYPE_GET_STAT, searchAPI.getStat);
const getBrandProductSaga = createRequestSaga(REQ_TYPE_GET_BRNAD_PRODUCT, searchAPI.getBrandProduct);
const getBrandProductDefaultSaga = createRequestSaga(REQ_TYPE_GET_BRNAD_PRODUCT_DEFAULT, searchAPI.getBrandProductDefault);
const getBrandProductAddSaga = createRequestSaga(REQ_TYPE_GET_BRNAD_PRODUCT_ADD, searchAPI.getBrandProduct);
const getCategoryInfoSaga = createRequestSaga(REQ_TYPE_GET_CATEGORY, searchAPI.getCategoryInfo);

export function* searchSaga() {
    yield takeLatest(REQ_TYPE_GET_BRNAD, getBrandSaga);
    yield takeLatest(REQ_TYPE_GET_BRNAD_DEFAULT, getBrandDefaultSaga);
    yield takeLatest(REQ_TYPE_GET_STAT, getStatSaga);
    yield takeLatest(REQ_TYPE_GET_BRNAD_PRODUCT, getBrandProductSaga);
    yield takeLatest(REQ_TYPE_GET_BRNAD_PRODUCT_DEFAULT, getBrandProductDefaultSaga);
    yield takeLatest(REQ_TYPE_GET_BRNAD_PRODUCT_ADD, getBrandProductAddSaga);
    yield takeLatest(REQ_TYPE_GET_CATEGORY, getCategoryInfoSaga);
}


/**
 * Store에 저장될 값 
 */
const initialState = {
    brandInfo: null,
    brandDefaultInfo: null,
    statInfo: null,
    brandProductInfo: null,
    brandProductDefaultInfo: null,

    errorBrand: null,
    errorBrandDefault: null,
    errorStat: null,
    errorBrandProduct: null,
    errorBrandProductDefault: null,
    errorBrandProductAdd: null,

    searchText: null,
    saveText: null,
    filterIndex: -1,
    selFilterData: null,    //브랜드 선택된 필터 데이터 저장 (data,type,offset)
    cateExist: [],
    searchCateInfo: null,
}

const searchReducer = handleActions(
    {
        [REQ_TYPE_GET_BRNAD_SUCCESS]: (state, { payload: brandInfo }) => {
            //console.log("success : " + JSON.stringify(brandInfo));
            return ({
                ...state,
                errorBrand: null,
                brandInfo: brandInfo,
            })
        },
        [REQ_TYPE_GET_BRNAD_FAILURE]: (state, { payload: error }) => {
            // console.log("error : " + JSON.stringify(error));
            return ({
                ...state,
                errorBrand: error,
                brandInfo: null,
            })
        },
        [REQ_TYPE_GET_BRNAD_DEFAULT_SUCCESS]: (state, { payload: brandDefaultInfo }) => {
            return ({
                ...state,
                errorBrandDefault: null,
                brandDefaultInfo: brandDefaultInfo,
            })
        },
        [REQ_TYPE_GET_BRNAD_DEFAULT_FAILURE]: (state, { payload: error }) => {
            // console.log("error : " + JSON.stringify(error));
            return ({
                ...state,
                errorBrandDefault: error,
                brandDefaultInfo: null,
            })
        },
        [REQ_TYPE_GET_BRNAD_PRODUCT_SUCCESS]: (state, { payload: brandProductInfo }) => {
            //console.log("REQ_TYPE_GET_BRNAD_PRODUCT_SUCCESS : " + JSON.stringify(brandProductInfo));
            // console.log("REQ_TYPE_GET_BRNAD_PRODUCT_SUCCESS");
            return ({
                ...state,
                errorBrandProduct: null,
                brandProductInfo: brandProductInfo,
            })
        },
        [REQ_TYPE_GET_BRNAD_PRODUCT_FAILURE]: (state, { payload: error }) => {
            // console.log("error : " + JSON.stringify(error));
            return ({
                ...state,
                errorBrandProduct: error,
                brandProductInfo: null,
            })
        },

        [REQ_TYPE_GET_BRNAD_PRODUCT_ADD_SUCCESS]: (state, { payload: brandProductInfo }) => {
            //console.log("REQ_TYPE_GET_BRNAD_PRODUCT_SUCCESS : " + JSON.stringify(brandProductInfo));
            // console.log("REQ_TYPE_GET_BRNAD_PRODUCT_ADD_SUCCESS");
            let dataList = state.brandProductInfo.dataList.concat(brandProductInfo.dataList);

            let data = Object.assign({}, state.brandProductInfo);
            data.dataList = [];
            Object.assign(data.dataList, dataList);

            return ({
                ...state,
                errorBrandProduct: null,
                brandProductInfo: data,
            })
        },
        [REQ_TYPE_GET_BRNAD_PRODUCT_ADD_FAILURE]: (state, { payload: error }) => {
            // console.log("error : " + JSON.stringify(error));
            return ({
                ...state,
                errorBrandProductAdd: error,
            })
        },

        [REQ_TYPE_GET_BRNAD_PRODUCT_DEFAULT_SUCCESS]: (state, { payload: brandProductDefaultInfo }) => {
            return ({
                ...state,
                errorBrandProductDefault: null,
                brandProductDefaultInfo: brandProductDefaultInfo,
            })
        },
        [REQ_TYPE_GET_BRNAD_PRODUCT_DEFAULT_FAILURE]: (state, { payload: error }) => {
            // console.log("error : " + JSON.stringify(error));
            return ({
                ...state,
                errorBrandProductDefault: error,
                brandProductDefaultInfo: null,
            })
        },
        [REQ_TYPE_GET_STAT_SUCCESS]: (state, { payload: statInfo }) => {
            return ({
                ...state,
                errorStat: null,
                statInfo: statInfo,
            })
        },
        [REQ_TYPE_GET_STAT_FAILURE]: (state, { payload: error }) => {
            // console.log("error : " + JSON.stringify(error));
            return ({
                ...state,
                errorStat: error,
                statInfo: null,
            })
        },
        [SET_SEARCH_TEXT]: (state, { payload: searchText }) => {
            return ({
                ...state,
                searchText: searchText,
            })
        },
        [SET_SAVE_TEXT]: (state, { payload: saveText }) => {
            return ({
                ...state,
                saveText: saveText,
            })
        },
        [SET_SEARCH_FILTER_INDEX]: (state, { payload: filterIndex }) => {
            return ({
                ...state,
                filterIndex: filterIndex,
            })
        },
        [SET_SEARCH_FILTER_DATA]: (state, { payload: selFilterData }) => {
            return ({
                ...state,
                selFilterData: selFilterData,
            })
        },
        [SET_SEARCH_BRAND_ERROR_RESET]: (state) => {
            return ({
                ...state,
                errorBrand: null,
            })
        },
        [SET_SEARCH_BRAND_DEFAULT_ERROR_RESET]: (state) => {
            return ({
                ...state,
                errorBrandDefault: null,
            })
        },
        [SET_SEARCH_BRAND_PRODUCT_ERROR_RESET]: (state) => {
            return ({
                ...state,
                errorBrandProduct: null,
            })
        },
        [SET_SEARCH_BRAND_PRODUCT_DEFAULT_ERROR_RESET]: (state) => {
            return ({
                ...state,
                errorBrandProductDefault: null,
            })
        },
        [SET_SEARCH_STAT_ERROR_RESET]: (state) => {
            return ({
                ...state,
                errorStat: null,
            })
        },
        [SET_SEARCH_BRAND_PRODUCT_ADD_ERROR_RESET]: (state) => {
            return ({
                ...state,
                errorBrandProductAdd: null,
            })
        },
        [REQ_TYPE_GET_CATEGORY_SUCCESS]: (state, { payload: Info }) => {
            // console.log("REQ_TYPE_HOME_INFO_BRAND_SUCCESS");
            let cateData = Info.numCatePrdct;
            let cateArray = [];
            if(cateData !== null && cateData !== undefined){
                cateData.forEach(cate1 => {
                    let cate2bucket = cate1.cate2.buckets;
                    cate2bucket.forEach(cate2 => {
                        let cate3bucket = cate2.cate3.buckets;
                        cate3bucket.forEach(cate3 => {
                            let cate = cate1.key*10000+cate2.key*100+cate3.key;
                            cateArray.push(cate);
                        });
                    });

                });

            }

            return ({

                ...state,
                error: null,
                searchCateInfo: Info,
                cateExist:cateArray,
            })
        },
        [REQ_TYPE_GET_CATEGORY_FAILURE]: (state, { payload: error }) => {
            // console.log("REQ_TYPE_HOME_INFO_BRAND_FAILURE : " + JSON.stringify(error));
            return ({
                ...state,
                error: error,
            })
        },

    }
    , initialState);

export default searchReducer;
